export const BUSINESS_VARIANT = 'Business'
export const ENTERPRISE_VARIANT = 'Enterprise'
